// Shared chrome for all _site+ routes: /, /about, /security, /privacy,
// /terms, /try, /gallery, etc. Renders the fixed SiteTopNav + a padded
// container (clearing the fixed nav) + SiteFooter. Each child route
// owns its own <main> so route-specific layout/width stays local.
//
// Precedent: books+/_layout.tsx and report+/_layout.tsx use the same
// _layout.tsx pattern.
//
// 2026-08-21: root.tsx's exact-match allow-list was removed (was silently
// double-navving nested marketing routes like /gallery). This layout is now
// the sole chrome for unauthed marketing routes; no root-side coordination
// needed. Adding a new marketing route means dropping a file under
// _site+/ - full stop.

import { Outlet } from 'react-router'
import { SiteFooter } from '#app/components/site-footer.tsx'
import { SiteTopNav } from '#app/components/site-top-nav.tsx'

export default function SiteLayout() {
	return (
		<div className="flex min-h-screen flex-col">
			<SiteTopNav />
			<div className="flex-1 pt-14">
				<Outlet />
			</div>
			<SiteFooter />
		</div>
	)
}
